import React from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30870" id="hero" ref={ref} className="relative w-full overflow-hidden bg-background py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute top-[20%] right-[0%] h-[500px] w-[500px] rounded-full bg-secondary/5 blur-3xl" />
      </div>

      <div className="container relative mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className={cn("flex flex-col items-start space-y-8 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <div className="space-y-4">
              <h1 className="text-5xl font-semibold font-display tracking-tight text-foreground leading-[1.1] !text-left sm:text-6xl lg:text-7xl">Claridad no es una sesión. Es un proceso.</h1>
              <p className="max-w-xl text-2xl font-medium font-display text-muted-foreground leading-relaxed">Hay momentos en los que entender lo que pasa no es suficiente. El verdadero cambio ocurre cuando sostienes una decisión en el tiempo. Programa Claridad es un acompañamiento de 6 semanas, diseñado para parar, entender lo que ocurre y elegir con más conciencia, sin forzarse.</p>
            </div>

            <div className="flex flex-col w-full sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 text-lg rounded-md shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 bg-primary text-foreground hover:bg-primary-hover">
                <Link to="/ContactReserveSessionPage">Solicitar acceso al Programa Claridad </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-md border-primary/20 text-foreground hover:bg-primary/5 hover:text-foreground hover:border-primary">
                
              </Button>
            </div>
            <p className="text-sm text-muted-foreground">Acceso mediante formulario · Sin compromiso</p>

            
          </div>

          {}
          <div className={cn("relative mx-auto w-full max-w-lg lg:max-w-none transition-all duration-1000 delay-200 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            <div className="relative rounded-2xl bg-muted/30 p-2 ring-1 ring-border/50 backdrop-blur-sm">
              <div className="relative aspect-[4/3] overflow-hidden rounded-xl bg-background shadow-2xl">
                <img src="https://guillermobogao.com/wp-content/uploads/2026/02/IMG_5186.jpg" alt="Real estate agent handing over keys to a new homeowner" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent mix-blend-overlay" />
              </div>

              {}
              
            </div>
            
            {}
            <div className="absolute -inset-4 -z-10 rounded-[2rem] bg-gradient-to-tr from-primary/20 to-secondary/20 blur-2xl opacity-60" />
          </div>
        </div>
      </div>
    </section>;
}